import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../constants/constants.service';
import { DataService } from '../utils/data/data.service';
import { Session } from '../session/session.service';

@Injectable()
export class RegionesService implements OnInit
{
    constructor(
      private http: HttpClient,
      private session: Session,
      private dataService: DataService
    ){
    }

    ngOnInit(){}
    listaRegiones(datos, callback){
      var formData: FormData;
      formData = new FormData();

      this.http
      .post(
        Constants.API_BASE + "/regiones/listarRegiones",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    crearRegion(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/regiones/crearRegion",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    editarRegion(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/regiones/editarRegion",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/regiones/regiones.service.ts